<template>
	<button type="button" class="tile" :class="{ on: on }" @click="$emit('toggle')">
		<span class="t"><span v-if="brandClass" class="bdot" :class="brandClass"></span><slot></slot>{{ label }}<span class="ck"><i class="fa-solid fa-check"></i></span></span>
		<span v-if="sub" class="s">{{ sub }}</span>
	</button>
</template>

<script>
import { brandKey } from './PeBrandChip.vue'

export default {
	name: 'PeTile',
	props: {
		label: { type: String, default: '' },
		sub: { type: String, default: '' },
		brand: { type: String, default: '' }, // TW, HG, CM, VT, TWK: the dot before the label; the default slot takes an icon instead
		on: { type: Boolean, default: false },
	},
	computed: {
		brandClass() { return brandKey(this.brand).toLowerCase() },
	},
}
</script>
